<template>
  <div class="mt-4 flex space-x-2">
    <div
      v-for="i of 3"
      :key="i"
      class="shimmer h-9 w-[110px] whitespace-nowrap rounded-2xl px-4 py-2"
    ></div>
  </div>
</template>
